(function() {
	'use strict';
	angular
		.module('app')
		.filter('filtrocatproduct', filtrocatproduct);

	filtrocatproduct.$inject = ["$http", "$window", "$location"];

	function filtrocatproduct($http, $window, $location) {
		return function(diseases, types) {



			if (!diseases || !types) return [];

			angular.forEach(types, function(type, typeKey) {

				var campito = types[typeKey].campito;
				var todos = types[typeKey].todos;
				if (!campito) return;

				angular.forEach(diseases, function(item, itemKey) {

					var itemValue = diseases[itemKey][campito];
					var isActive = false;
					if (itemValue !== undefined) {

						if (Array.isArray(itemValue)) {

							isActive = itemValue.every(cat => type[cat.id]);
						} else {
							isActive = type[itemValue] == true;
						}
						if (todos || isActive) {
							diseases[itemKey].hide = 0;
						} else {
							diseases[itemKey].hide = 1;
						}

					}



					angular.forEach(diseases[itemKey].products, function(product, pKey) {

						var productValue = product[campito];
						var isProductActive = false;

						if (productValue !== undefined) {
							if (Array.isArray(productValue)) {
								isProductActive = productValue.some(cat => type[cat.id]);
							} else {

								isProductActive = type[productValue] == true;

							}


							if (Array.isArray(product["skus_id"])) {


								angular.forEach(diseases[itemKey].products[pKey].skus_id, function(sku, sKey) {

									if (todos || sku.caracteristics_sku_id.some(cat => type[cat])) {
										diseases[itemKey].products[pKey].skus_id[sKey].hide = 0;
									} else {
										diseases[itemKey].products[pKey].skus_id[sKey].hide = 1;
									}


								})

							}


							if (todos || isProductActive) {

								diseases[itemKey].products[pKey].hide = 0;
							} else {

								diseases[itemKey].products[pKey].hide = 1;
							}
						}




					});

				});
			});

			return diseases;
		};
	}

})();


